import { ReactComponent as VehicleIcon } from "../../../assets/icons/dash/Wheel.svg";
import { ReactComponent as MoneyIcon } from "../../../assets/icons/moneys.svg";
import { ReactComponent as GroupIcon } from "../../../assets/icons/user-group.svg";
import { Separator } from "../../../components/ui/common";
import DashboardCard from "../../../components/ui/dashboard/DashboardCard";
import { useGetPartnerStatsQuery } from "../partnerApiSlice";

const PartnerDashStats = () => {
  const { data, isLoading } = useGetPartnerStatsQuery();

  const expenseStat = data?.data ?? {
    totalPartners: 0,
    totalEarnings: 0,
    totalVehicles: 0,
  };

  const cards = [
    {
      label: "Total partners",
      value: `${expenseStat.totalPartners.toLocaleString()}`,
      icon: <GroupIcon className="h-8 w-8" />,
      index: 0,
    },
    {
      label: "Vehicles onboarded",
      value: `${expenseStat.totalEarnings.toLocaleString()}`,
      icon: <VehicleIcon className="h-8 w-8" />,
      index: 1,
    },
    {
      label: "Net banked",
      value: `₦${expenseStat.totalVehicles.toLocaleString()}`,
      icon: <MoneyIcon className="h-8 w-8" />,
      index: 2,
    },
  ];

  return (
    <div className="flex flex-wrap gap-x-4 gap-y-4 sm:gap-x-10 sm:gap-y-6 bg-white rounded-[10px] p-4">
      {cards.map(({ label, value, icon, index }) => (
        <>
          <DashboardCard
            key={index}
            icon={icon}
            value={isLoading ? "0" : value}
            label={label}
            className="w-[300px]"
          />

          {index < cards?.length - 1 && <Separator />}
        </>
      ))}
    </div>
  );
};

export default PartnerDashStats;
